import { css } from "lit";

export const landingStyles = css`
  .hollo-landing {
    display: grid;
    grid-template-rows: 1fr auto;
    place-items: stretch;
    height: 100%;
    position: relative;
    border: none;
    border-bottom: none;
    box-shadow: none;
    outline: none;
    overflow: hidden;
  }
  .hollo-live-landing-height {
    height: 200px;
  }

  @media (max-width: 460px) {
    .hollo-live-landing-height {
      height: 40dvh;
    }
  }

  .hollo-messages {
    overflow-y: auto;
    overflow-x: hidden;
    padding: 12px 8px 8px;
    display: grid;
    align-content: start;
    gap: 12px;
    background: #fff;
    scroll-behavior: smooth;
    scroll-padding-bottom: 8px;
    min-height: 0;
    overflow-anchor: none;

    /* Custom scrollbar styles */
    --sb-track-color: #f9fafb;
    --sb-thumb-color: #d1d5db;
    --sb-size: 6px;
  }
  
  .hollo-messages:has(.hollo-empty-container) {
    overflow-y: hidden;
    padding-bottom: 8px;
  }

  .hollo-messages::-webkit-scrollbar {
    width: var(--sb-size);
  }

  .hollo-messages::-webkit-scrollbar-track {
    background: var(--sb-track-color);
    border-radius: 3px;
  }

  .hollo-messages::-webkit-scrollbar-thumb {
    background: var(--sb-thumb-color);
    border-radius: 3px;
    transition: background 0.2s;
  }

  .hollo-messages::-webkit-scrollbar-thumb:hover {
    background: #9ca3af;
  }

  @supports not selector(::-webkit-scrollbar) {
    .hollo-messages {
      scrollbar-color: var(--sb-thumb-color) var(--sb-track-color);
    }
  }
  .hollo-row {
    display: flex;
    animation: hollo-message-enter 0.6s cubic-bezier(0.2, 0.9, 0.3, 1) backwards;
    will-change: transform, opacity;
  }
  .hollo-row.hollo-left {
    justify-content: flex-start;
  }
  .hollo-row.hollo-right {
    justify-content: flex-end;
  }

  @keyframes hollo-message-enter {
    from {
      opacity: 0;
      transform: translateY(4px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .hollo-bubble-box {
    position: relative;
    max-width: 80%;
    padding-bottom: 16px;
  }
  .hollo-bubble {
    display: inline-block;
    width: fit-content;
    max-width: 100%;
    padding: 8px 12px 12px 12px; /* Figma: 8px top, 12px sides/bottom */
    border-radius: 20px; /* Figma rounded bubble */

    color: #021820; /* Figma text color for received */
    font-size: 16px; /* Figma */
    line-height: 1.25; /* Figma */
    font-weight: 500; /* Figma */
    font-family: "Segoe UI", "Helvetica Neue", Helvetica, Arial, sans-serif;
    word-wrap: break-word;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
    position: relative;
  }
  .hollo-row.hollo-right .hollo-audio-bubble .hollo-bubble {
    max-width: 100%;
  }
  .hollo-message-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 8px;
    padding-top: 4px;
    border-top: none;
    width: 100%;
  }
  .hollo-user-message-footer {
    justify-content: flex-end;
  }
  .hollo-message-icons {
    display: flex;
    align-items: center;
    gap: 8px;
  }
  .hollo-message-icon-btn {
    background: transparent;
    border: none;
    cursor: pointer;
    padding: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #6c7e85;
    width: auto;
    height: auto;
    min-width: 28px;
    min-height: 28px;
    border-radius: 6px;
    opacity: 0.7;
    transition: opacity 0.2s ease, transform 0.15s ease,
      background-color 0.2s ease;
    position: relative;
  }
  .hollo-message-icon-btn:hover {
    opacity: 1;
    background-color: rgba(108, 126, 133, 0.08);
  }
  .hollo-message-icon-btn:active {
    opacity: 0.8;
  }
  .hollo-message-icon-btn.hollo-audio-playing {
    opacity: 1;
  }
  .hollo-message-icon-btn.hollo-audio-playing svg {
    animation: hollo-audio-pulse 1.5s ease-in-out infinite;
  }
  @keyframes hollo-audio-pulse {
    0%,
    100% {
      opacity: 1;
    }
    50% {
      opacity: 0.8;
    }
  }
  .hollo-icon-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    width: 100%;
    height: 100%;
  }
  .hollo-icon-wrapper svg,
  .hollo-icon-wrapper span {
    display: block;
    flex-shrink: 0;
    animation: hollo-icon-fade-in 0.25s cubic-bezier(0.16, 1, 0.3, 1);
  }
  @keyframes hollo-icon-fade-in {
    from {
      opacity: 0;
      transform: rotate(-8deg);
    }
    to {
      opacity: 1;
      transform: rotate(0deg);
    }
  }
  .hollo-message-icon-btn.hollo-icon-copied .hollo-icon-wrapper svg {
    animation: hollo-icon-success 0.4s cubic-bezier(0.16, 1, 0.3, 1);
  }
  @keyframes hollo-icon-success {
    0% {
      opacity: 0;
      transform: rotate(-15deg);
    }
    50% {
      transform: rotate(5deg);
    }
    100% {
      opacity: 1;
      transform: rotate(0deg);
    }
  }
  .hollo-message-icon-btn.hollo-video-active .hollo-icon-wrapper svg {
    animation: hollo-icon-pulse 0.3s ease-out;
  }
  @keyframes hollo-icon-pulse {
    0%,
    100% {
      opacity: 1;
    }
    50% {
      opacity: 0.7;
    }
  }
  .hollo-message-timestamp {
    color: #6c7e85;
    font-size: 12px;
    font-weight: 400;
    font-family: "Segoe UI", "Helvetica Neue", Helvetica, Arial, sans-serif;
    line-height: 1;
    white-space: nowrap;
    opacity: 0.7;
  }
  .hollo-user-message-footer .hollo-message-timestamp {
    color: #fff;
    opacity: 0.7;
  }
  /* Disable old CSS square tails; we now render SVG tails */
  .hollo-row.hollo-left .hollo-bubble::after,
  .hollo-row.hollo-right .hollo-bubble::after {
    content: none;
    display: none;
  }
  .hollo-row.hollo-left .hollo-bubble {
    background: #f3f3f3; /* Figma received bubble */
    color: #021820;
    border-bottom-left-radius: 12px;
    font-weight: 400; /* Lighter weight for AI messages */
    font-size: 14px;
  }
  /* Tail positioning and sizing */
  .hollo-tail {
    position: absolute;
    width: 16.5px;
    height: 17px;
    z-index: 3;
  }
  .hollo-tail svg {
    display: block;
    width: 100%;
    height: 100%;
  }
  .hollo-tail-left {
    left: 6px; /* align near left radius */
    bottom: 6px; /* visually attach to bubble */
  }
  .hollo-tail-right {
    right: -5px;
    bottom: 6px;
    transform: scaleX(-1); /* mirror to point right */
  }
  .hollo-row.hollo-right .hollo-bubble {
    background: #00adee;
    color: #fff;
    border-bottom-right-radius: 12px;
  }
  /* end tails */

  .hollo-bubble.hollo-typing {
    display: inline-flex;
    gap: 6px;
    align-items: center;
    animation: hollo-typing-bubble-enter 0.3s ease-out;
  }
  @keyframes hollo-typing-bubble-enter {
    from {
      opacity: 0;
      transform: scale(0.9);
    }
    to {
      opacity: 1;
      transform: scale(1);
    }
  }
  .hollo-bubble.hollo-typing .hollo-dot {
    width: 6px;
    height: 6px;
    border-radius: 999px;
    background: currentColor;
    opacity: 0.35;
    animation: blink 1.2s infinite ease-in-out;
    transform-origin: center;
  }
  .hollo-bubble.hollo-typing .hollo-dot:nth-child(2) {
    animation-delay: 0.2s;
  }
  .hollo-bubble.hollo-typing .hollo-dot:nth-child(3) {
    animation-delay: 0.4s;
  }
  @keyframes blink {
    0%,
    80%,
    100% {
      opacity: 0.2;
      transform: scale(1);
    }
    40% {
      opacity: 0.9;
      transform: scale(1.2);
    }
  }

  .hollo-bubble-fab {
    position: relative;
    border-radius: 999px;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color: #fff;
    background: transparent;
    box-shadow: none;
    pointer-events: auto;
    width: 24px;
    height: 24px;
  }
  .hollo-row.hollo-right .hollo-bubble-fab {
    display: none;
  }

  span.hollo-spinner-small {
    width: 14px;
    height: 14px;
    max-width: 14px;
    max-height: 14px;
    min-width: 14px;
    min-height: 14px;
    border: 2px solid #6c7e85;
    border-top-color: #fff;
    border-radius: 50%;
    animation: hollo-spin 0.8s linear infinite !important;
    display: inline-block;
  }
  @keyframes hollo-spin {
    to {
      transform: rotate(360deg);
    }
  }

  .hollo-empty-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    height: 100%;
    padding-top: 16px;
    animation: hollo-empty-enter 0.4s cubic-bezier(0.16, 1, 0.3, 1);
  }
  @keyframes hollo-empty-enter {
    from {
      opacity: 0;
      transform: translateY(10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
  .hollo-avatar {
    width: 56px;
    height: 56px;
    border-radius: 50%;
    object-fit: cover;
    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.15);
    transition: transform 0.3s ease, box-shadow 0.3s ease;
  }
  .hollo-empty-container:hover .hollo-avatar {
    transform: scale(1.05);
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.2);
  }
  .hollo-prompt {
    margin: 12px 0 16px;
    text-align: center;
    color: #374151;
    font-size: 16px;
    animation: hollo-prompt-fade-in 0.5s ease-out 0.2s both;
  }
  @keyframes hollo-prompt-fade-in {
    from {
      opacity: 0;
      transform: translateY(5px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .hollo-composer {
    width: 100%;
    display: grid;
    // grid-template-columns: 44px 1fr 44px;
    gap: 0;
    align-items: center;
    padding: 12px 0 0 0;
    background: #fff;
    border: none;
    border-bottom: none;
    margin-bottom: 0;
    margin-top: 0;
    box-shadow: none;
    outline: none;
    transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
  }

  .hollo-recorder-active {
    // grid-template-columns: 44px 1fr;
    align-items: center;
  }

  /* Smooth transition between message bar and recorder */
  .hollo-messageBarContainer,
  .hollo-recorderBarContainer {
    animation: hollo-composer-enter 0.3s cubic-bezier(0.16, 1, 0.3, 1);
  }
  @keyframes hollo-composer-enter {
    from {
      opacity: 0;
      transform: translateY(4px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
  .hollo-input {
    height: 40px;
    border-radius: 999999px;
    border: 1px solid #e5e7eb;
    padding: 0 14px;
    font-size: 16px;
    outline: none;
    background: #f9fafb;
    color: #000;
  }
  .hollo-input:focus {
    background: #fff;
    border-color: #cbd5e1;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.12);
  }
  .hollo-icon-btn.hollo-mic,
  .hollo-icon-btn.hollo-wave,
  .hollo-icon-btn.hollo-send,
  .hollo-icon-btn.hollo-phone {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: transparent;
    color: #021820;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    cursor: pointer;
    flex-shrink: 0;
    padding: 0;
    margin: 0;
    transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1);
    transform-origin: center;
  }
  .hollo-icon-btn.hollo-mic:hover,
  .hollo-icon-btn.hollo-wave:hover,
  .hollo-icon-btn.hollo-phone:hover {
    background-color: transparent;
  }
  .hollo-icon-btn.hollo-mic:active,
  .hollo-icon-btn.hollo-wave:active,
  .hollo-icon-btn.hollo-phone:active {
    opacity: 0.8;
  }
  .hollo-icon-btn.hollo-send[disabled] {
    opacity: 0.5;
    cursor: not-allowed;
  }

  .hollo-audio-bubble {
    max-width: 85%;
  }
  .hollo-row.hollo-right .hollo-audio-bubble {
    max-width: 85%;
    min-width: 240px;
  }

  .hollo-caption.transcript {
    margin-top: 8px;
    font-size: 12px;
    line-height: 1.4;
  }

  .hollo-isAiVoice {
    display: none;
  }
  .hollo-bubble-actions {
    position: absolute;
    bottom: 8px;
    right: 8px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    pointer-events: none;
    z-index: 2;
  }
  .hollo-row.hollo-right .hollo-bubble-actions {
    display: none;
  }
  .hollo-bubble-box-inner {
    display: flex;
    align-items: start;
    gap: 0.5rem;
  }
  /* New hollo- prefixed Message Bar styles */
  .hollo-messageBarContainer {
    display: flex;
    align-items: center;
    gap: 0;
    width: 100%;
    background-color: #fff;
    padding: 0;
    border: none;
    border-bottom: none;
    margin-bottom: 0;
    box-shadow: none;
    flex-shrink: 0;
  }

  .hollo-sparkles {
    position: relative;
    flex-shrink: 0;
    width: 24px;
    height: 24px;
    cursor: pointer;
  }
  .hollo-sparkles svg {
    display: block;
    width: 100%;
    height: 100%;
  }

  .hollo-messageBar {
    position: relative;
    flex: 1 1 0%;
    min-width: 1px;
    min-height: 48px;
    background-color: #fff;
    border-radius: 9999px;
    flex-shrink: 0;
    box-shadow: none;
    transition: background-color 0.2s ease, box-shadow 0.2s ease;
  }
  .hollo-messageBar:focus-within {
    background-color: #fff;
    box-shadow: none;
  }
  .hollo-messageBarBorder {
    position: absolute;
    inset: 0;
    border: 1px solid #e5e7eb;
    border-radius: 9999px;
    pointer-events: none;
    z-index: 1;
  }
  .hollo-messageBarInner {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    height: 100%;
    position: relative;
    z-index: 2;
    min-height: 48px;
  }
  .hollo-messageBarContent {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    gap: 8px;
    padding: 0 12px;
    box-sizing: border-box;
    height: 100%;
    min-height: 48px;
  }
  .hollo-messageBarText {
    position: relative;
    flex: 1 1 0%;
    min-width: 1px;
    min-height: 1px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    color: #111827;
    font-size: 16px;
    font-family: "Segoe UI", "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-weight: 400;
    line-height: 1.5;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    flex-shrink: 0;
    margin: 0;
    padding: 0;
  }
  .hollo-messageBarText p {
    overflow: hidden;
    text-overflow: ellipsis;
    margin: 0;
  }
  .hollo-message-input {
    border: none;
    outline: none;
    background: transparent;
    color: #111827;
    font-size: 14px;
    font-family: "Segoe UI", "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-weight: 400;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    line-height: 1.5;
    transition: color 0.2s ease;
  }
  .hollo-message-input::placeholder {
    color: #9ca3af;
    font-size: 14px;
    transition: opacity 0.2s ease;
  }
  .hollo-message-input:focus::placeholder {
    opacity: 1;
  }

  .hollo-send {
    position: relative;
    width: 32px;
    height: 32px;
    background-color: #00adee;
    border-radius: 99px;
    flex-shrink: 0;
    overflow: hidden;
    border: none;
    display: grid;
    place-items: center;
    cursor: pointer;
    color: #fff;
    transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1);
    transform-origin: center;
  }
  .hollo-send:hover {
    background-color: #0099d6;
    box-shadow: 0 4px 12px rgba(0, 173, 238, 0.3);
  }
  .hollo-send:active {
    opacity: 0.9;
  }
  .hollo-send[disabled] {
    opacity: 0.5;
    cursor: default;
  }
  .hollo-up2 {
    position: absolute;
    width: 24px;
    height: 24px;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
  .hollo-up2 svg {
    display: block;
    width: 100%;
    height: 100%;
  }

  .hollo-waves {
    position: relative;
    width: 32px;
    height: 32px;
    flex-shrink: 0;
    overflow: hidden;
    background: #00adee;
    border-radius: 50%;
    padding: 0;
    border: none;
    display: grid;
    place-items: center;
    cursor: pointer;
    transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1);
    transform-origin: center;
  }
  .hollo-waves:hover {
    background-color: #0099d6;
    box-shadow: 0 4px 12px rgba(0, 173, 238, 0.3);
  }
  .hollo-waves:active {
    opacity: 0.9;
  }
  .hollo-wavesGroup {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .hollo-wavesGroupInner {
    position: relative;
    width: 19px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .hollo-wavesGroupInner svg {
    display: block;
    width: 100%;
    height: 100%;
  }

  /* Recorder UI (hollo- prefixed) */
  .hollo-recorderBarContainer {
    display: flex;
    align-items: center;
    gap: 8px;
    background-color: transparent;
    width: 100%;
    height: 100%;
  }
  .hollo-recorderBinButton {
    position: relative;
    width: 48px;
    height: 48px;
    border-radius: 50%;
    overflow: visible;
    flex-shrink: 0;
    display: grid;
    place-items: center;
    background: transparent;
    border: 1px solid #bbc6ca;
    cursor: pointer;
    transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1);
    transform-origin: center;
  }
  .hollo-recorderBinButton:hover {
    background-color: rgba(239, 68, 68, 0.05);
    border-color: #ef4444;
  }
  .hollo-recorderBinButton:active {
    opacity: 0.8;
  }
  .hollo-recorderBinIcon {
    position: relative;
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .hollo-recorderBinIcon svg {
    display: block;
    width: 100%;
    height: 100%;
  }
  .hollo-recorderBar {
    position: relative;
    flex: 1 1 0%;
    min-width: 1px;
    min-height: 48px;
    background-color: #f9fafb;
    border-radius: 999px;
    flex-shrink: 0;
    overflow: hidden;
    transition: background-color 0.2s ease;
  }
  .hollo-recorderBarBorder {
    position: absolute;
    inset: 0;
    border: 1px solid #e5e7eb;
    border-radius: 999px;
    pointer-events: none;
    z-index: 1;
  }
  .hollo-recorderBarInner {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    height: 100%;
    position: relative;
    z-index: 2;
    min-height: 48px;
  }
  .hollo-recorderBarContent {
    box-sizing: border-box;
    display: grid;
    grid-template-columns: auto 1fr auto;
    align-items: center;
    width: 100%;
    padding: 0 12px;
    height: 100%;
    column-gap: 0;
    row-gap: 0;
    position: relative;
  }
  .hollo-recordingLeft {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
    min-width: fit-content;
    width: auto;
    justify-content: flex-start;
  }
  .hollo-recordingDot {
    position: relative;
    width: 10px;
    height: 10px;
    flex-shrink: 0;
    margin-right: 0;
  }
  .hollo-timerWaveformContainer {
    display: flex;
    align-items: center;
    gap: 8px;
    justify-content: flex-start;
    flex: 1;
    min-width: 0;
    width: 100%;
    overflow: hidden;
    margin-left: 0;
    padding-left: 0;
  }
  .hollo-timerText {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    font-family: "Segoe UI", "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-size: 14px;
    line-height: 1;
    color: #d20446;
    text-align: left;
    white-space: nowrap;
    flex-shrink: 0;
    margin: 0 0 0 8px;
    padding: 0;
    height: auto;
    min-width: fit-content;
  }
  .hollo-timerText-centered {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    margin: 0;
    padding: 0;
    pointer-events: none;
    z-index: 10;
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 1;
  }
  .hollo-waveform-wrapper {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    min-width: 0;
    overflow: hidden;
    padding: 0;
    flex: 1;
    width: 100%;
  }
  .hollo-recordingDot.hollo-blink {
    animation: hollo-blink-dot 1.5s ease-in-out infinite;
  }
  @keyframes hollo-blink-dot {
    0%,
    100% {
      opacity: 1;
      transform: scale(1);
    }
    50% {
      opacity: 0.3;
      transform: scale(0.9);
    }
  }
  .hollo-recordingDot svg {
    display: block;
    width: 100%;
    height: 100%;
  }
  .hollo-timerText p {
    margin: 0;
    padding: 0;
    white-space: pre;
    line-height: 1;
    font-size: 14px;
    display: inline-block;
    vertical-align: middle;
  }
  .hollo-waveform {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 2px;
    height: 32px;
    flex: 1;
    min-width: 0;
    margin-right: 12px;
  }
  .hollo-waveform-bar {
    flex: 1;
    max-width: 3px;
    min-height: 4px;
    background: #9ca3af; /* gray when not talking */
    border-radius: 2px;
    transition: height 120ms cubic-bezier(0.16, 1, 0.3, 1),
      background-color 150ms ease, transform 120ms ease;
    animation: hollo-waveform-pulse 0.8s ease-in-out infinite;
  }
  .hollo-waveform.hollo-talking .hollo-waveform-bar {
    background: #021820; /* black when talking */
    transform: scaleY(1.05);
  }
  .hollo-waveform-bar:nth-child(4n + 1) {
    animation-delay: 0s;
  }
  .hollo-waveform-bar:nth-child(4n + 2) {
    animation-delay: 0.1s;
  }
  .hollo-waveform-bar:nth-child(4n + 3) {
    animation-delay: 0.2s;
  }
  .hollo-waveform-bar:nth-child(4n) {
    animation-delay: 0.3s;
  }
  @keyframes hollo-waveform-pulse {
    0%,
    100% {
      transform: scaleY(0.4);
    }
    50% {
      transform: scaleY(1);
    }
  }
  .hollo-recorderSendContainer {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 8px;
    flex-shrink: 0;
    min-width: fit-content;
  }
  .hollo-recorderSendButton {
    position: relative;
    width: 32px;
    height: 32px;
    background-color: #00adee;
    border-radius: 99px;
    overflow: hidden;
    flex-shrink: 0;
    display: grid;
    place-items: center;
    border: none;
    cursor: pointer;
    color: #fff;
    transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1);
    transform-origin: center;
  }
  .hollo-recorderSendButton:hover {
    background-color: #0099d6;
  }
  .hollo-recorderSendButton:active {
    opacity: 0.9;
  }
  .hollo-recorderUpIcon {
    position: absolute;
    width: 24px;
    height: 24px;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    transition: transform 0.2s ease;
  }
  .hollo-recorderUpIcon svg {
    display: block;
    width: 100%;
    height: 100%;
  }
`;
